
import consumablesList_cus from './list.vue'


import * as consumablesClaim_cus from './claim.vue'
import * as record_cus from './record'


let a = Object.assign({ consumablesList_cus},consumablesClaim_cus,record_cus)
export default a
